<template>
    <div :id="id" tabindex="-1" aria-labelledby="modal-form" :class="styleClass.modal">
        <div :class="styleClass.modalDialog" role="document">
            <div class="modal-content pl-2 pr-2">
                <div class="modal-header">
                    <h3 v-if="title" v-text="title"></h3>
                    <slot v-else name="header"></slot>
                    <button type="button" class="close" data-toggle="modal" aria-label="Close" ref="closeButton" :data-target="selector">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body pt-0 pb-0">
                    <slot></slot>
                </div>
                <div class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";

export default {
    name: "Modal",
    computed: {

        id() {
            return `modal-component-${ this._uid }`
        },
        
        selector() {
            return `#${ this.id }`
        },

        styleClass() {
            return {
                modal: {
                    'modal': true,
                    'fade': true,
                    // 'modal-lg': !this.small,
                },
                modalDialog: {
                    'modal-dialog': true,
                    'modal-dialog-centered': true,
                    'modal-lg': this.size === "regular",
                    'modal-xl': this.size === "large",
                }
            }
        }

    },

    data() {
        return {
            fullscreen: false,
            icon: false,
            show: this.value,
        }
    },

    methods: {

        initializeModal() {
            $(this.selector).on('show.bs.modal', () => {
                // this.$nextTick(() => this.$emit("input", this.show = true))
            })
            $(this.selector).on('hide.bs.modal', e => {
                this.$emit('hidden', e);
                if (!e.target.classList.contains('modal')) {
                    e.preventDefault();                    
                    return
                }
                
                // this.$nextTick(() => this.$emit("input", this.show = false))
                // this.$nextTick(() => this.show = false)
            })
            $(this.selector).modal('hide');
        },

        toggleVisibility() {
            $(this.selector).modal(this.show ? 'show' : 'hide');
        }
    },

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        subtitle: String,
        title: String,
        size: {
            type: String,
            default: "small",
        },
    },

    watch: {
        show() {
            this.toggleVisibility();
        },

        value(newValue) {
            this.show = newValue
        },
    },

    mounted() {
        this.initializeModal();
    },
}
</script>
<style lang="css" scoped>
    .modal-content {
        border-radius: 4px;
    }
    @media (min-width:992px) {
        .modal-lg,.modal-xl {
            max-width:800px;
        }
    }
    @media (min-width:1200px) {
        .modal-xl{max-width:1140px;
        }
    }
</style>